import { createContext } from 'react'

import type { ApiClient } from '@/lib/api'
import type { ConsoleConfig } from '@/lib/env/config'

export interface ConsoleContextValue {
  readonly config: ConsoleConfig
  readonly api: ApiClient
  /**
   * CLAUDE.md Part II §19 — on a standby cell every mutating control is
   * disabled. Screens read this rather than checking the role themselves, so
   * there is one answer to "may I write?" and it cannot drift.
   */
  readonly mutationsAllowed: boolean
}

export const ConsoleContext = createContext<ConsoleContextValue | null>(null)
